import { useEffect, useRef, useState } from 'react';

export default function BeforeAfterSlider({ before, after, alt = 'before after' }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const onMove = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    setPos((x / rect.width) * 100);
  };

  useEffect(() => {
    const move = (e) => { if (dragging.current) onMove(e.clientX ?? e.touches?.[0]?.clientX); };
    const up = () => { dragging.current = false; };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    window.addEventListener('touchmove', move);
    window.addEventListener('touchend', up);
    return () => {
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
      window.removeEventListener('touchmove', move);
      window.removeEventListener('touchend', up);
    };
  }, []);

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="ba-slider relative aspect-[16/10] w-full overflow-hidden rounded-2xl select-none"
      onMouseDown={(e) => { dragging.current = true; onMove(e.clientX); }}
      onTouchStart={(e) => { dragging.current = true; onMove(e.touches[0].clientX); }}
    >
      {/* After image (full underneath) */}
      <img
        src={after}
        alt={`${alt} after`}
        draggable={false}
        className="absolute inset-0 w-full h-full object-cover pointer-events-none"
      />
      {/* Before image (clipped to pos% from left) */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)`, WebkitClipPath: `inset(0 ${100 - pos}% 0 0)` }}
      >
        <img
          src={before}
          alt={`${alt} before`}
          draggable={false}
          className="absolute inset-0 w-full h-full object-cover"
        />
      </div>
      {/* Handle */}
      <div className="ba-handle pointer-events-none" style={{ left: `calc(${pos}% - 1.5px)` }} />
      <div className="absolute top-4 left-4 pill !text-white !border-white/40 !bg-black/40 pointer-events-none">Before</div>
      <div className="absolute top-4 right-4 pill !text-white !border-white/40 !bg-black/40 pointer-events-none">After</div>
    </div>
  );
}
